module.exports = __webpack_public_path__ + "static/media/ss7.9b99c351.jpg";